const Theme = {
  body_background_color: '#FFFFFF',
  title_font: 'Neue Haas Unica',
  title_margin_left: 7,
  text_font: 'Neue Haas Unica',
  text_weight: 700,
  logo_image_url: 'lico.png',
  token_hidden: true,
  number_hidden: true,
  header_full_height: true,
  header_no_margin: true,
  header_no_border: true,
  logo_full_width: true,
  button_border_width: 1,
  button_color: '#254497',
  button_hover_text_color: '#254497',
  button_radius: 0,
  button_outlined_border_color: '#254497',
  button_outlined_hover_border_color: '#254497'
}

export default Theme